module.exports = __webpack_public_path__ + "img/gurushots-dark.e09697a5.svg";